import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

export interface Vendor {
  id: string;
  displayName: string;
}

export interface PackageVersions {
  allotropy: string;
  benchlingAsmParser: string;
}

export function convertToAsm(
  blobOrFileId: string,
  vendor?: string | null,
  connectionId?: string | null
): Promise<{blobId: string; detectedVendor: string | null}> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/connect-files:convert-to-asm',
    data: {blobOrFileId, vendor, connectionId},
  });
}

export function convertToCsv(
  blobOrFileId: string,
  transformType?: string,
  mapperConfig?: string | null,
  newBlobName?: string,
  asmVendor?: string,
  connectionId?: string | null
): Promise<Array<{blobId: string; transformDataType: string}>> {
  return TaskRunner.postJSONPromise({
    url: '/1/api/connect-files:convert-to-csv',
    data: {blobOrFileId, transformType, mapperConfig, newBlobName, asmVendor, connectionId},
  });
}

export function listTransformDataTypes(asmVendor?: string): Promise<{[key: string]: string}> {
  const params: {asmVendor?: string} = {};
  if (asmVendor) {
    params.asmVendor = asmVendor;
  }
  return net.getJSONPromise('/1/api/instruments/transform-data-types', params);
}

export function getPackageVersions(): Promise<PackageVersions> {
  return net.getJSONPromise('/1/api/connect-files/package-versions');
}

export function listVendors(): Promise<Array<Vendor>> {
  return net.getJSONPromise('/1/api/connect-files/vendors');
}

export function getSpreadsheetColumns(
  fileId: string,
  adapterId: string,
  transformDataType: string,
  delimiter?: string,
  inferDataTypes?: boolean
): Promise<{columns: Array<string>; data_types?: Array<string>}> {
  return net.postJSONPromise({
    url: '/1/api/instruments/connect-files/get-spreadsheet-columns',
    data: {fileId, adapterId, transformDataType, delimiter, inferDataTypes},
  });
}
